import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { analyticsBiometricRegistrationFailedModalViewed } from '@perpay-web/fintech/actions/analytics/biometrics';
import BiometricRegistrationFailedModal from '@perpay-web/fintech/components/composite/BiometricRegistrationFailedModal/BiometricRegistrationFailedModal';
import { useBiometricRegistrationFailedModalContext } from '@perpay-web/fintech/hooks/useBiometricRegistrationFailedModalContext';
import { useNativeSelector } from '@perpay-web/native-client/hooks/useNativeSelector';
import { getBiometricsType } from '@perpay-web/native-client/selectors/passkey';

const BiometricRegistrationFailedModalContainer = () => {
    const { setIsAnimatedModalOpen, animatedModalClassName } =
        useBiometricRegistrationFailedModalContext();
    const dispatch = useDispatch();
    const biometricsType = useNativeSelector(getBiometricsType);

    const onMount = useCallback(
        () => dispatch(analyticsBiometricRegistrationFailedModalViewed()),
        [dispatch],
    );

    return (
        <BiometricRegistrationFailedModal
            onMount={onMount}
            className={animatedModalClassName}
            onClickClose={() => setIsAnimatedModalOpen(false)}
            biometricsType={biometricsType}
        />
    );
};

export default BiometricRegistrationFailedModalContainer;
